// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__W3f+K","main":"styles_main__54pjG","pages":"styles_pages__4vwd1"};